export default __webpack_public_path__ + "static/media/safety.6c67326d.png";